import React from 'react';

import delayedModalClose from 'settings/product-listing/utils/delayModalClose';

const SavingStatus = (props) => {
  const { productsList, cancel, resetSavedProperty } = props;
  const { errorMessage, isPosting, isSaved } = productsList;
  if (isPosting) return <div />;
  if (isSaved) {
    delayedModalClose(cancel, resetSavedProperty);
    return <div />;
  }

  if (errorMessage) {
    delayedModalClose(cancel, resetSavedProperty, 0);
    return <div />;
  }
  return <div />;
};

export default SavingStatus;
